import React from "react";
import ReviewStep from "./ReviewStep";
import { useOnboarding } from "context/OnboardingContext";

const ContactReview = () => {
  const { claimMeta } = useOnboarding();
  const claimLabel = claimMeta?.claim_type === "build_device"
    ? "Build + Device"
    : claimMeta?.claim_type === "device"
    ? "Device"
    : "Build";

  return (
    <ReviewStep
      stepKey="contact"
      title={`${claimLabel} Contact`}
      fields={[
        { name: "first_name", label: "First Name" },
        { name: "last_name", label: "Last Name" },
        { name: "email", label: "Email" },
        { name: "phone", label: "Phone" },
      ]}
    />
  );
};

export default ContactReview;
